export const defaultStyles = {
  alignment: "center",
  backgroundColor: "var(--theme-email-primary-button-background-color)",
  lineHeight: "var(--theme-email-primary-button-line-height)",
  borderColor: "var(--theme-email-primary-button-border-color)",
  borderRadius: {
    border_left_top_radius:
      "var(--theme-email-primary-button-border-left-top-radius)",
    border_left_bottom_radius:
      "var(--theme-email-primary-button-border-left-bottom-radius)",
    border_right_top_radius:
      "var(--theme-email-primary-button-border-right-top-radius)",
    border_right_bottom_radius:
      "var(--theme-email-primary-button-border-right-bottom-radius)",
  },
  borderWidth: "var(--theme-email-primary-button-border-width)",
  color: "var(--theme-email-primary-button-text-color)",
  fontFamily: "var(--theme-email-primary-button-font-family)",
  fontSize: "var(--theme-email-primary-button-font-size)",
  fontStyle: "normal",
  fontWeight: "var(--theme-email-primary-button-font-weight)",
  letterSpacing: "var(--theme-email-primary-button-letter-spacing)",
  textAlign: "center",
  textDecoration: "none",
  textTransform: "none",
  sizing: {
    width: "auto",
    height: "auto",
    minWidth: "auto",
    minHeight: "auto",
    maxWidth: "auto",
    maxHeight: "auto",
  },
  padding: {
    paddingTop: "var(--theme-email-primary-button-padding-top)",
    paddingBottom: "var(--theme-email-primary-button-padding-bottom)",
    paddingLeft: "var(--theme-email-primary-button-padding-left)",
    paddingRight: "var(--theme-email-primary-button-padding-right)",
  },
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
} as const;
